export const ROOT = 'StepPayment/formPayment/dni';

export const FETCH_DNI_REQUEST = `${ROOT}/FETCH_DNI_REQUEST`;
export const FETCH_DNI_FAILURE = `${ROOT}/FETCH_DNI_FAILURE`;
export const FETCH_DNI_SUCCESS = `${ROOT}/FETCH_DNI_SUCCESS`;

export const UPDATE_DNI_REQUEST = `${ROOT}/UPDATE_DNI_REQUEST`;
export const UPDATE_DNI_FAILURE = `${ROOT}/UPDATE_DNI_FAILURE`;
export const UPDATE_DNI_SUCCESS = `${ROOT}/UPDATE_DNI_SUCCESS`;

export const CREATE_DNI_REQUEST = `${ROOT}/CREATE_DNI_REQUEST`;
export const CREATE_DNI_FAILURE = `${ROOT}/CREATE_DNI_FAILURE`;
export const CREATE_DNI_SUCCESS = `${ROOT}/CREATE_DNI_SUCCESS`;

export const CLEAR_DNI_DATA = `${ROOT}/CLEAR_DNI_DATA`;
export const SET_DISABLED_DNI_INPUTS = `${ROOT}/DISABLED_DNI_INPUTS`;
